<template>
  <dropdown
    v-model:value="authorUserId"
    label="Auteur"
    :options="authors"
    :disabled="!enabled"
    :is-loading="isLoading"
  />
</template>

<script>
import Dropdown from '@/components/UI/Dropdown.vue';

import { getAll as getAllUsers } from '@/api/providers/users'

import { getDefaultAuthorId } from '@/helpers/organization-settings'

export default {
  components: {
    Dropdown
  },
  
  props: {
    modelValue: {
      type: [Number, null],
      required: true
    },
    
    enabled: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'update:modelValue'
  ],

  data() {
    return {
      authors: [],
      isLoading: true,
    }
  },
  
  computed: {
    authorUserId: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) }
    }
  },


  async mounted() {
    let promises = Promise.all([
      this.fetchUsers(),
      this.fetchDefaultAuthorId()
    ]);

    promises.then(([
      users,
      defaultAuthorId
    ]) => {
      this.authors = users;

      const index = this.authors.findIndex(u => u.value == defaultAuthorId);

      if (this.modelValue == null) {
        this.$emit(
          'update:modelValue',
          index > -1
            ? this.authors[index].value
            : null
        );
      }

      this.isLoading = false
    });
  },

  methods: {
    async fetchUsers() {
      let apiUsers = await getAllUsers();

      apiUsers = apiUsers.filter(u => u.isAdmin || u.id === this.authorUserId);

      return apiUsers.map(
        u => ({
          value: u.id, 
          label: `${u.firstName ?? ''} ${u.insertion ?? ''} ${u.lastName != null ? u.lastName.charAt(0) : ''}.`,
          image: u.profilePicture
        })
      );
    },

    async fetchDefaultAuthorId() {
      return getDefaultAuthorId();
    }
  }
};

</script>

<style scoped lang="scss">
.summary {
  &__image {
  
    &-column {
      width: 120px;
    }
  }
}

.summary-visual {
  &__image {
    aspect-ratio: 1;
    object-fit: cover;
  }

  &-remove {
    transition: opacity .2s;

    &:not(:hover) {
      opacity: 0;
    }

    &__background {
      opacity: .75;
    }
  }
}

.user-profile-image {
    margin-left: -3px;
    width:100px;
}
</style>
